import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IResponseModel } from '../Shared/model/CommonModel';
import { IOpenCashModel, IPOSTerminal } from '../Shared/Interfaces/IPOSSettings';

@Injectable({
    providedIn: 'root',
})
export class PosOpeningCashDrawerService {
    private baseURL: string;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getPOSTerminals(marketId: number = 0): Observable<IPOSTerminal[]> {
        let params: any = {};

        if (marketId && marketId > 0) {
            params.marketId = marketId;
        }

        return this.http.get<any>(
            `${this.baseURL}/POSOpeningCash/GetPOSTerminals`,
            {
                params,
                observe: 'response'
            }
        ).pipe(
            map(res => {
                const result = res.body as IPOSTerminal[];
                return result;
            }),
            catchError(this.handleError)
        );
    }

    checkOpenCashSavedForTransaction(): Observable<any> {
        return this.http.get<any>(`${this.baseURL}/POSOpeningCash/CheckOpenCashSavedForTransaction`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as any;
                return result;
            }),
            catchError(this.handleError));
    }

    savePOSTerminal(model: IPOSTerminal): Observable<IResponseModel> {
        return this.http.post<any>(`${this.baseURL}/POSOpeningCash/SavePOSTerminal`, model, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IResponseModel>) => res.body),
            catchError(this.handleError)
        );
    }

    deletePOSTerminal(id: number): Observable<IResponseModel> {
        return this.http.delete<any>(`${this.baseURL}/POSOpeningCash/DeletePOSTerminal?id=${id}`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as IResponseModel;
                return result;
            }),
            catchError(this.handleError));
    }

    getOpeningCash(terminalName: string, dateTime: string, userId: number): Observable<IOpenCashModel> {
        return this.http.get<any>(`${this.baseURL}/POSOpeningCash/GetOpeningCash?terminalName=${terminalName}&dateTime=${dateTime}&userId=${userId}`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as IOpenCashModel;
                return result;
            }),
            catchError(this.handleError));
    }

    saveOpeningCash(model: IOpenCashModel): Observable<IResponseModel> {
        return this.http.post<any>(`${this.baseURL}/POSOpeningCash/SaveOpeningCash`, model, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IResponseModel>) => res.body),
            catchError(this.handleError)
        );
    }
    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
